export default __webpack_public_path__ + "8f5600596017f08ee5fd234b05be4416.svg";